import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Toast } from '../configs/toast';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class ErrorsService {
    constructor() { }

    heddleError(error: HttpErrorResponse) {
        this.showErrorSwal(error);
    }

    showErrorSwal(error: HttpErrorResponse) {
        const isBadRequest = error.status === 400;
        const isClientError = error.status >= 400 && error.status < 500;
        
        if (isBadRequest) {
            // Para Bad Request usar icono de warning
            Swal.fire('Atención', error.error.message, 'warning');
        } else if (isClientError) {
            // Para otros errores del cliente (401, 403, 404, etc.) usar warning
            Swal.fire('Atención', error.error.message || 'Error en la solicitud', 'warning');
        } else {
            // Para errores críticos del servidor (500, etc.) usar error
            Swal.fire('Algo salió mal', error.error.message || 'Error interno del servidor', 'error');
        }
    }
}